import { render, staticRenderFns } from "./Patrimonio.vue?vue&type=template&id=183b3236"
import script from "./Patrimonio.vue?vue&type=script&lang=js"
export * from "./Patrimonio.vue?vue&type=script&lang=js"
import style0 from "./Patrimonio.vue?vue&type=style&index=0&id=183b3236&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports